/**
 * A product can be enabled only when it is not composed of an inactive component
 */
export const isProductEnableable = ({ entity }) => !entity || entity.active;

/**
 * Splits a selection between the products that can be enabled and the ones that will be skipped
 */
export const getEnableableProducts = (products) => products.filter(isProductEnableable);
